import { SegmentedControl, useMantineColorScheme, type MantineColorScheme } from "@mantine/core";
import { useTranslation } from "react-i18next";

/**
 * Hell, Dunkel oder wie das Betriebssystem (#337). Gemerkt wird die Wahl je
 * Browser, von Mantine im localStorage (`mantine-color-scheme-value`); das
 * Skript in `index.html` liest denselben Schlüssel vor dem ersten Bild.
 */
export function ColorSchemeSwitcher() {
  const { t } = useTranslation();
  const { colorScheme, setColorScheme } = useMantineColorScheme();

  return (
    <SegmentedControl
      size="xs"
      fullWidth
      aria-label={t("colorScheme.label")}
      value={colorScheme}
      onChange={(value) => setColorScheme(value as MantineColorScheme)}
      data={[
        { label: t("colorScheme.light"), value: "light" },
        { label: t("colorScheme.dark"), value: "dark" },
        { label: t("colorScheme.auto"), value: "auto" },
      ]}
    />
  );
}
